// extracted by mini-css-extract-plugin
module.exports = {"screenreaderonly":"_1jv5-7","clearfix":"_2TdCFt","headingBlock":"_3MPhTg _2rGMVt","swipableHeadingBlockContainer":"_3Vg3u2"};